import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {useQuery} from '@apollo/client';
import {gql} from '@apollo/client';

import Loading from '../../../component/loading/Loading';
import {PRODUCT_FRAGMENT} from '../../../component/productPreview/ProductPreview';
import {PRODUCT_LIST_ITEM_FRAGMENT} from '../../../query/productFragments';
import ProductsListItem from '../../../component/productsList/productsListItem/ProductsListItem';
import {isMobile} from '../../../util/navigator';

import './HorizontalProductsList.css';

const PLACEHOLDER_DATA = {
    items: [{
        id: '-1',
        title: '\xa0',
        status: 'selling',
        brand: '\xa0',
        external_url: null,
        price: -1,
        resizedSmallImages: []
    }]
};

// GraphQL queries
const FILTERED_PRODUCTS = gql`
    query seeProductsCached($filter: ProductFilter!, $sort: String!, $limit: Int!) {
        items: searchProducts(filter: $filter, sort: $sort, limit: $limit) {
            ...ProductFragment
            ...ProductListItemFragment
            price
        }
    }
    ${PRODUCT_FRAGMENT}
    ${PRODUCT_LIST_ITEM_FRAGMENT}
`;

const COLLECTION_PRODUCT = gql`
    query GetCollectionProducts($collectionId: Int!) {
        items: getCollectionProducts(collection_id: $collectionId, offset: 0, limit: 20) {
            ...ProductFragment
            ...ProductListItemFragment
            price
        }
    }
    ${PRODUCT_FRAGMENT}
    ${PRODUCT_LIST_ITEM_FRAGMENT}
`;

/**
 * Horizontal products list component.
 */
export default function HorizontalProductsList({ userAgent, rowClassName, variables, isCollectionProduct = false, isMultiple = false, limit = 20, query, setIsVisible}) {
    const { loading, data } = useQuery(
        query ? query : isCollectionProduct ? COLLECTION_PRODUCT : FILTERED_PRODUCTS,
        {
            variables: {
                ...variables,
                limit,
            },
            fetchPolicy: 'cache-and-network'
        }
    );

    // build the UI elements
    // render invisible placeholder data while loading, to set the container height and guarantee a stable layout
    const items = (data || PLACEHOLDER_DATA).items.map((product, index) => (
        <li className={`HorizontalProductsList-item col ${loading && !data ? 'HorizontalProductsList-item--loading' : ''}`}
            key={index}>
            <ProductsListItem product={product} />
        </li>
    ));

    useEffect(() => {
        if ((data || PLACEHOLDER_DATA).items.length === 0) {
            setIsVisible && setIsVisible(false);
        }
    }, [data, PLACEHOLDER_DATA]);


    return (
        <ul className={`HorizontalProductsList list-inline row  ${rowClassName} ${isMobile(userAgent) ? 'HorizontalProductsList--mobile' : ''} ${isMultiple && !isMobile(userAgent) ? `HorizontalProductsList--multiple` : ''}`}>
            {loading && !data && (
                <li className="HorizontalProductsList-loading">
                    <Loading />
                </li>
            )}
            {items}
        </ul>
    );
}
HorizontalProductsList.propTypes = {
    userAgent: PropTypes.string.isRequired,
    rowClassName: PropTypes.string.isRequired,
    variables: PropTypes.object.isRequired,
    isMultiple: PropTypes.bool,
    isCollectionProduct: PropTypes.bool,
    limit: PropTypes.number,
    query: PropTypes.object,
    setIsVisible: PropTypes.func,
};
